import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const phrasepreventions = 
{
    namespaced: true,
    state: {
        phrasepreventions: [],
        phraseprevention: {}
    },
    mutations: {
        SET_PHRASEPREVENTIONS(state, data)
        {
            state.phrasepreventions = data
        },
        SET_PHRASEPREVENTION(state, data)
        {
            state.phraseprevention = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'PhrasePrevention', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_PHRASEPREVENTIONS', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deletePhrasePreventions ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updatePhrasePreventions({ commit }, {id, data}){
            return axios
            .post(baseUrl+'PhrasePrevention/updatePhrasePrevention/'+id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getPhrasePreventions ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewPhrasePreventions ({ commit }, data) {
            return axios
            .post(baseUrl+'PhrasePrevention/addPhrasePrevention', data, { withCredentials: true },)
            .then(res => {
                console.log("new phrase prevention added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default phrasepreventions